import { observer } from "mobx-react-lite";
import { Outlet } from "react-router-dom";

const WorkspaceSettings = () => {
	// const { t } = useTranslation("translation", { keyPrefix: "tabsLayout" });
	// const { appStore, authStore } = useAppStore();

	// const isIpProjectsEnabled = useLdFeatureFlag(FEATURE_FLAGS.IP_PROJECTS_FEATURE) || isHanukaOrgs();
	// const isFreeSubscription = authStore.orgSubscription?.plan_name === ORG_SUBSCRIPTION_PLANS.free.name;

	// const workspaceTabs = [
	// { name: t("related-organizations"), link: RouterConstants.RELATED_ORGANIZATIONS.fullPath },
	// { name: t("users"), link: RouterConstants.USERS.fullPath },
	// ...(authStore?.user?.isSuperAdmin() ||
	// getSelectedOrganization()?.organization.uid === TOON_BOOM_ANIMATION_ORG_ID
	// 	? [{ name: t("attribution-reports"), link: RouterConstants.AttributionReports.fullPath }]
	// 	: []),
	// { name: t("api-keys"), link: RouterConstants.AUTH_KEYS.fullPath },
	// ...(isIpProjectsEnabled ? [{ name: t("IP-projects"), link: RouterConstants.IP_PROJECTS.fullPath }] : []),
	// ...(isEditorRole(getSelectedOrganization()?.role ?? "") && !isFreeSubscription
	// 	? [{ name: t("mfa_settings"), link: RouterConstants.MFA_SETTINGS_TAB.fullPath }]
	// 	: []),
	// ];

	return (
		// <TabsLayout
		// 	title={t("workspace-settings", { keyPrefix: false })}
		// 	subtitle={<OrgNameEditor />}
		// 	subTabs={workspaceTabs}
		// 	isLoading={appStore.isLoading}
		// >
		<Outlet />
		// </TabsLayout>
	);
};

export default observer(WorkspaceSettings);
